import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { breakfastType, dinnerType, breakfastPage, dinnerPage, arrivalTimePage, arrivalType } from '../../utils';
import BookMore from '../bookMore/BookMore';
import './EmptyEventCard.scss';

const getTypeText = (type) => {
  if (type === breakfastType) return 'Breakfast';
  if (type === dinnerType) return 'Dinner';
  return 'Arrival time';
};

const getLinkPath = (type) => {
  if (type === breakfastType) return breakfastPage;
  if (type === dinnerType) return dinnerPage;
  return arrivalTimePage;
};

const EmptyEventCard = ({ type, bookText }) => (
  <div className="empty-event-card">
    <div className="empty-event-card-content-wrapper">
      <div className="text">{getTypeText(type)}</div>
      <Link className="book-more" to={getLinkPath(type)}>
        <BookMore text={bookText} />
      </Link>
    </div>
    {
      type === arrivalType && (
        <div className="empty-card-explanatory-text">
          We’ve noticed you’ve not selected your preferred arrival time. Please click here to let our team know what time you’ll be arriving.
        </div>
      )
    }
  </div>
);

EmptyEventCard.propTypes = {
  type: PropTypes.string.isRequired,
  bookText: PropTypes.string.isRequired,
};

export default EmptyEventCard;
